import React, { Suspense, lazy } from 'react'; // Added Suspense and lazy
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import {
  ThemeProvider as StyledThemeProvider,
  createGlobalStyle,
} from 'styled-components';
import ThemeProvider, { useTheme } from './providers/ThemeProvider';
import { AuthProvider } from './providers/AuthProvider';
import styled from 'styled-components';
import Header from './components/header/index';
import Footer from './components/footer/index';
import Home from './components/home/index';
import About from './components/about/index';
import Contact from './components/contact/index';
import { lightTheme, darkTheme } from './theme';
import Gallery from './components/gallery';
import Programs from './components/programs';
import Educational from './components/educational';
// import Donations from './components/donations';
import CalendarEvents from './components/calendar';
import LangarCalendar from './components/langar-calendar';
import ErrorBoundary from './components/ErrorBoundary';
const ProcessDonationPage = lazy(() => import('pages/ProcessDonationPage')); // Lazy load

const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  body {
    margin: 0;
    padding: 0;
    /* overflow: hidden; REMOVED - This was preventing page scroll */
    /* Ensure fonts support all languages. Consider adding a Punjabi font like 'Noto Sans Gurmukhi' */
    /* Example: font-family: 'Noto Sans Gurmukhi', ${(props) =>
      props.theme.fontFamilies.secondary}; */
    font-family: ${(props) => props.theme.fontFamilies.secondary}; 
    color: ${(props) => props.theme.colors.text}; /* Updated text color */
    background-color: ${(props) =>
      props.theme.colors.background}; /* Updated background color */
    line-height: ${(props) =>
      props.theme.lineHeights.body}; /* Applied body line height */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    /* Example: font-family: 'Noto Sans Gurmukhi', ${(props) =>
      props.theme.fontFamilies.primary}; */
    font-family: ${(props) => props.theme.fontFamilies.primary}; 
    line-height: ${(props) =>
      props.theme.lineHeights.heading}; /* Heading line height */
    color: ${(props) => props.theme.colors.text}; /* Default heading color */
    margin-top: 0; /* Example reset, adjust as needed */
    /* margin-bottom: 0.5rem; Example reset */
  }

  h1 { font-size: ${(props) => props.theme.fontSizes.h1}; }
  h2 { font-size: ${(props) => props.theme.fontSizes.h2}; }
  h3 { font-size: ${(props) => props.theme.fontSizes.h3}; }
  /* Add h4, h5, h6 if defined in theme.fontSizes */

  a {
    color: ${(props) => props.theme.colors.link}; /* Updated link color */
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: ${(props) =>
        props.theme.colors.accentHover}; /* Updated hover color */
      text-decoration: underline;
    }
  }
`;

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Container = styled.main`
  /* Changed from div to main */
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  &::-webkit-scrollbar {
    width: 0; /* Safari and Chrome */
    height: 0;
  }

  @media (max-width: 768px) {
    /* Remove padding from main scrollable container if pages handle their own */
    /* Or, add some minimal padding here if pages don't have it */
  }
`;

const AppContent: React.FC = () => {
  const { theme } = useTheme(); // useTheme is now called in a child of ThemeProvider
  return (
    <StyledThemeProvider theme={theme === 'light' ? lightTheme : darkTheme}>
      <GlobalStyle />
      <AppContainer>
        <Router>
          <Header />
          <Suspense fallback={<div>Loading...</div>}>
            {' '}
            {/* Suspense wrapper */}
            <Container>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/about" element={<About />} />
                <Route path="/programs" element={<Programs />} />
                <Route path="/educational" element={<Educational />} />
                <Route path="/donations" element={<ProcessDonationPage />} />
                <Route
                  path="/process-donation"
                  element={<ProcessDonationPage />}
                />
                <Route path="/calendar" element={<CalendarEvents />} />
                <Route path="/langar-calendar" element={<LangarCalendar />} />
              </Routes>
            </Container>
          </Suspense>
          <Footer />
        </Router>
      </AppContainer>
    </StyledThemeProvider>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        {' '}
        {/* Custom ThemeProvider wraps AppContent */}
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
export default App;
